import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: '/devices', pathMatch: 'full' },
      {
        path: 'devices',
        loadChildren: () =>
          import('./devices-management/devices-management.module').then(m => m.DevicesManagementModule),
      },
      {
        path: 'firmwares',
        loadChildren: () => import('./firmwares/firmwares.module').then(m => m.FirmwaresModule),
      },
    ],
  },
  { path: '**', redirectTo: '/devices', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
